import produce from 'immer';
import React, { useState } from 'react';
import { Button, Spinner } from 'reactstrap';
import { putPractitionerRole } from '../../apis/practitionerRole';
import { usePractitioner } from '../../contexts/practitioner';

const RevokeButton = () => {
  const [loading, setLoading] = useState(false);
  const { practitionerRoles, setPractitionerRoles } = usePractitioner();
  return (
    <Button
      className="float-right mr-2"
      color="danger"
      disabled={
        !practitionerRoles ||
        practitionerRoles.filter(pr => pr.active).length <= 0
      }
      onClick={async () => {
        if (!practitionerRoles) return;
        try {
          setLoading(true);
          const role = produce(practitionerRoles[0], draft => {
            draft.active = false;
          });
          if (!role || !role.id) return;
          const response = await putPractitionerRole(role.id, role);
          if (!response) return;

          setPractitionerRoles(
            produce(practitionerRoles, draft => {
              const index = draft.findIndex(pr => pr.id === response.id);

              if (index < 0) draft.push(response);
              else draft[index] = response;
            }),
          );
        } finally {
          setLoading(false);
        }
      }}>
      {loading ? <Spinner size="sm" /> : 'Revoke'}
    </Button>
  );
};
export default RevokeButton;
